import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=4f9f802c&scoped=true&"
import script from "./classification.vue?vue&type=script&lang=js&"
export * from "./classification.vue?vue&type=script&lang=js&"
import style0 from "./classification.vue?vue&type=style&index=0&id=4f9f802c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f802c",
  null
  
)

export default component.exports